<template>
    <div>
        <div class="seleccion">
        <div class="titulo_caja"><h4 class="titulo">{{titulo}}</h4></div>
        <select  @change="cambioDeSeccion($event)" class="col-12" >
        <option :key="0" >Seleccione Año</option>
        <option v-for="(contenido,index) in contenidos" :key="index" :value="contenido.RutaDeArchivo"> {{contenido.TextoDelContenido}}</option>
        </select>
    </div>
    </div>
</template>



<script>
export default {
    props:{
        contenidos: Array,
        titulo: String
    },
    methods: {
      columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
        },
    cambioDeSeccion($event){
        console.log($event.target.value)
        this.$router.push($event.target.value)
    }
    },
}
</script>

<style scoped>
.titulo{
    margin-bottom: 1em;
}
.seleccion {
  appearance: none;

  margin-top: 2em;
  margin-bottom: 2em;
  position: relative;
}

.seleccion select {
  display: inline-block;
  width: 100%;
  cursor: pointer;
  padding: 7px 10px;
  height: 42px;
  outline: 0;
  border: 0;
  border-radius: 0;
  background: #f0f0f0;
  color: #7b7b7b;
  font-size: 1.5em;
  color: #999;
  font-family: "AntenaBeta";
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-radius: 12px;
  position: relative;
  transition: all 0.25s ease;
  text-align: center;
}
.titulo_caja{
    background-color: black;
    color: #f0f0f0;
    text-align: center;
    padding-top: .6em;
    padding-bottom: 1px;
    height: 4em;
    margin-bottom: 1em;



    

}

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/SelectSimple.vue